export const CROSS_SALE_ACTIONS = {
    CROSS_SALE_SEARCH: 'CROSS_SALE_SEARCH',
    CROSS_SALE_SEARCH_SUCCESS: 'CROSS_SALE_SEARCH_SUCCESS',

    CROSS_SALE_INSERT: 'CROSS_SALE_INSERT',

    CROSS_SALE_REMOVE: 'CROSS_SALE_REMOVE',

};

export const crossSaleRemoveAction = (payload) => ({
    type: CROSS_SALE_ACTIONS.CROSS_SALE_REMOVE,
    ...payload,
});

export const crossSaleSearchAction = (payload) => ({
    type: CROSS_SALE_ACTIONS.CROSS_SALE_SEARCH,
    ...payload,
});

export const crossSaleInsertAction = (payload) => ({
    type: CROSS_SALE_ACTIONS.CROSS_SALE_INSERT,
    ...payload,
});

export default {
    CROSS_SALE_ACTIONS,
    crossSaleRemoveAction,
    crossSaleSearchAction,
    crossSaleInsertAction,
};
